import GoToLinkButton from '@/shared/Buttons/GoToLinkButton'
import urls from '@/navigation/urls'
import equipmentUtils from '@/pages/Equipment/equipment.utils'
import { IEquipment } from '@/pages/Equipment/equipment.types'
import SeparateLine from '@/shared/Forms/SeparateLine'
import css from './calendarSidePageViewContent.module.css'
import timeUtils from '@/utils/time.utils'
import { IMaintenanceBlankSchema } from '@/pages/Processes/Maintenance/maintenance.types'
import ThreeDotsLoader from '@/shared/Loaders/ThreeDotsLoader'
import BasicTable from '@/shared/Tables/BasicTable'
import { IUser } from '@/pages/Users/users.types'
import { IMaintenanceEvent } from '@/pages/Calendar/calendar.types'
import MaintenanceEventTypeLabel from '@/pages/Calendar/CalendarWeekView/components/MaintenanceEventTypeLabel/MaintenanceEventTypeLabel'
import { NavLink, useNavigate } from 'react-router-dom'
import Button from '@/shared/Buttons/Button'
import FileAddLine from '@/assets/icons/fileAddLine.svg?react'
import maintenanceUtils from '@/pages/Equipment/components/Maintenance/maintenance.utils'
import userUtils from '@/pages/User/user.utils'

interface IProps {
  onClose: () => void
  event: IMaintenanceEvent
  equipment: IEquipment
  maintenanceBlankSchema: IMaintenanceBlankSchema
  responsibleUsers: IUser[]
}

const CalendarSidePageViewContent = (props: IProps) => {
  const navigate = useNavigate()

  if (!props.equipment || !props.maintenanceBlankSchema) {
    return (
      <div className="flex-lines center" style={{ marginTop: '100px' }}>
        <ThreeDotsLoader inscription="Загружаем данные..." />
      </div>
    )
  }

  const tableCol = ['Наименование', 'Содержание работ', 'Технические требования']

  const tableValues = []
  for (let field of props.maintenanceBlankSchema.fields) {
    tableValues.push([
      <span className="text-nm" style={{ whiteSpace: 'pre-wrap' }}>
        {field.name}
      </span>,
      <span className="text-nm" style={{ whiteSpace: 'pre-wrap' }}>
        {field.instruction}
      </span>,
      <span className="text-nm" style={{ whiteSpace: 'pre-wrap' }}>
        {field.requirements}
      </span>,
    ])
  }

  const renderToFillBlankBlock = () => {
    const isCompleted = props.event.type === 'COMPLETED_MAINTENANCE'
    if (isCompleted) return null
    const { isDateInGracePeriod, start, end } = maintenanceUtils.isDateInMaintenancePeriod(new Date(props.event.ts))
    const isOverdue = props.event.type === 'OVERDUE_MAINTENANCE'
    const isWarningNeeded = !isCompleted && !isOverdue && !isDateInGracePeriod
    return (
      <div className="flex-lines gap16" style={{ paddingRight: '24px' }}>
        <SeparateLine />
        <div className="inline-flex-gap gap16 center">
          <Button
            disabled={isCompleted || !isDateInGracePeriod}
            onClick={() =>
              navigate(urls.liftPageMaintenanceCreateBlank(props.equipment.id, props.event.metadata.processRuleId))
            }
            size="default"
            type="primary"
            text="Заполнить Бланк ТО"
            icon={<FileAddLine className="text-white" />}
          />
          {isWarningNeeded && (
            <p className="text-nm text-warning" style={{ alignSelf: 'center' }}>
              Бланк обслуживания необходимо будет заполнить в любое время с {timeUtils.formatDate(start, 'dd.MM.yyyy')}{' '}
              по
              {' ' + timeUtils.formatDate(end, 'dd.MM.yyyy')}
            </p>
          )}
        </div>
      </div>
    )
  }

  const renderResponsibleUsers = () => {
    const text = props.responsibleUsers
      ?.map((item) => userUtils.getFullName(item.userInfo))
      .filter(Boolean)
      .join(', ')

    return <p className="text-nm">{text || '-'}</p>
  }

  return (
    <div className="flex-lines height100 gap16">
      <div className="flex-lines gap16" style={{ paddingRight: '24px' }}>
        <div className="flex-lines gap12" style={{ alignItems: 'start' }}>
          <MaintenanceEventTypeLabel eventType={props.event.type} />
          <h4 className="text-heading-4" style={{ width: '85%' }}>
            {equipmentUtils.getEquipmentAddress(props.equipment.location)}
          </h4>
        </div>
        <GoToLinkButton to={urls.liftScreen(props.event.metadata.equipmentId)} text="Устройство" />
        <SeparateLine />
        <div className={css.sidePageGrid}>
          <p className="text-nm text-secondary">
            {props.event.type === 'PLANNED_MAINTENANCE' ? 'Плановая дата ТО:' : 'Дата проведения ТО:'}
          </p>
          <p className="text-nm">{timeUtils.formatDate(new Date(props.event.ts), 'dd.MM.yyyy')}</p>
          <p className="text-nm text-secondary">Ответственные:</p>
          {renderResponsibleUsers()}
          <p className="text-nm text-secondary">Бланк ТО:</p>
          <NavLink to={urls.maintenance} className="text-nm text-link" style={{ textDecoration: 'none' }}>
            {props.maintenanceBlankSchema.name}
          </NavLink>
        </div>
        <SeparateLine />
      </div>
      <div style={{ overflow: 'auto', flex: '1 1 0%', paddingRight: '18px' }}>
        <BasicTable columns={tableCol} values={tableValues} />
      </div>
      {renderToFillBlankBlock()}
    </div>
  )
}

export default CalendarSidePageViewContent
